import { render, staticRenderFns } from "./AddMerchantAccount.vue?vue&type=template&id=653b37f5"
import script from "./AddMerchantAccount.vue?vue&type=script&lang=js"
export * from "./AddMerchantAccount.vue?vue&type=script&lang=js"
import style0 from "./AddMerchantAccount.vue?vue&type=style&index=0&id=653b37f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports